export default "__VITE_ASSET__oiTzxx23__"